import supabase from "artifact/supabase";
import Vimeo from "artifact/vimeo";
import connected from "standard/connected";
import define from "standard/define";
import didPaint from "standard/didPaint";
import joinCut from "standard/joinCut";
import paint from "standard/paint";
import trait from "standard/trait";
import style from "./style";

@define("m-video")
class Video extends HTMLElement {
  #element;
  #id;
  #options;
  #player;
  #user;
  #video;

  get [trait.element]() {
    return (this.#element ??= this.shadowRoot.querySelector("div"));
  }

  get [trait.id]() {
    return (this.#id ??= this.getAttribute("data-id"));
  }

  get [trait.options]() {
    return (this.#options ??= {
      byline: false,
      portrait: false,
      title: false,
      url: `https://player.vimeo.com/video/${this[trait.id]}`,
    });
  }

  get [trait.user]() {
    return (this.#user ??= this.getAttribute("data-user"));
  }

  get [trait.video]() {
    return (this.#video ??= this.getAttribute("data-video"));
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <div class="${style.video}">
        <img class="${style.video__cover}" src="//donna.sistemadulino.com.br/cover.jpg" alt="cover" loading="eager" />
      </div>
    `;
  }

  @didPaint
  @joinCut(trait.progress)
  @joinCut(trait.ended)
  [trait.player]() {
    this.#player = new Vimeo(this[trait.element], this[trait.options]);
    return this;
  }

  [trait.progress]() {
    this.#player?.on("progress", async (data) => {
      if (data.percent <= 0.9) return;

      await supabase
        .from("video_completed")
        .insert([
          {
            video_id: this[trait.video],
            user_id: this[trait.user],
            date: new Date().getTime(),
          },
        ])
        .select();
    });
    return this;
  }

  [trait.ended]() {
    this.#player?.on("ended", () => location.reload());
    return this;
  }
}

export default Video;
